import React, {useState} from 'react';
import clsx from 'clsx';

import {Button, Typography} from '@nur-portal/ui-kit';

// eslint-disable-next-line max-len
import {StepPhone} from '../../../modules/comments/components/modal-comments/authenticated-overlay/components/step-phone';

import styles from './index.module.css';

const AddPhoneModal = ({onClose}) => {
  const [formStep, setFromStep] = useState(false);
  const nullishFunction = () => {};

  if (formStep) {
    return (
      <StepPhone
        goNext={onClose}
        onPhoneCancelClick={onClose}
        onPhoneChangeSuccess={onClose}
        onPhoneSubmitClick={nullishFunction}
        onSMSCodeSubmitClick={nullishFunction}
      />
    );
  }

  return (
    <div className={styles.wrapper}>
      <Typography variant='title-16' className={styles.title}>Подтвердите ваш номер телефона</Typography>
      <Typography
        variant='text-14'
        className={styles.text}
      >
        {/* eslint-disable-next-line max-len */ }
        Для участия в голосовании на NUR.KZ требуется активный аккаунт и подтверждение казахстанского номера телефона. Это условие нужно для обеспечения безопасности и предотвращения манипуляций с голосами.
      </Typography>
      <div className={styles.buttonsWrapper}>
        <Button
          variant='primary'
          className={clsx(styles.primaryButton, styles.button)}
          onClick={() => setFromStep(true)}
        >
          Подтвердить
        </Button>
        <Button
          variant='secondary'
          onClick={onClose}
          className={clsx(styles.button, styles.cancelButton)}
        >
          Не сейчас
        </Button>
      </div>
    </div>
  );
};

export {AddPhoneModal};
